










































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { checkMobile } from '../../utils/utils'
import MaterialCard from '../../materials/Card.vue'
import UserBlock from '../../../api/v2/models/user_block'
import UserForm from '../../../api/v2/forms/user_form'
import api from '../../../api/v2/api'
import { userState } from '../../stores/user'
import { headerState } from '../../stores/header'

const defaultAvt =
  'https://i0.wp.com/www.winhelponline.com/blog/wp-content/uploads/2017/12/user.png?resize=256%2C256&quality=100&ssl=1'

@Component({
  components: {
    MaterialCard
  }
})
export default class UserUpdateFormView extends Vue {
  @Prop({
    default: true
  })
  showPreview: boolean = true

  @Prop({
    default: 'user_update'
  })
  mode: 'user_update' | 'guest_update' = 'user_update'

  mobile: boolean = false
  form = new UserForm()
  image: any = defaultAvt
  groups: UserBlock[] = []

  completeDialog = false

  get user() {
    return userState.user
  }

  get isGuestUpdate() {
    return this.mode == 'guest_update'
  }

  get errorMessage() {
    return userState.errorMessage
  }

  get isLoading() {
    return userState.isLoading
  }

  get schoolSetting() {
    return headerState.schoolSetting
  }

  async created() {
    this.mobile = checkMobile()
    this.groups = await api.userBlock.index()
  }

  mounted() {
    this.setUser()
    userState.getUser()
  }

  @Watch('user')
  setUser() {
    if (this.user) {
      if (!this.user.isGuestExamOnly || this.user.unconfirmedEmail) {
        this.form.name = this.user.name
        this.form.email = this.user.email
      } else {
        this.form.name = ''
        this.form.email = ''
      }
      this.form.userBlockId = this.user.userBlockId
      if (this.user.image) {
        this.image = this.user.image.url
      } else {
        this.image = defaultAvt
      }
    }
  }

  onFileChange(e) {
    const files = e.target.files || e.dataTransfer.files
    if (!files.length) return
    this.createImage(files[0])
  }

  createImage(file: File) {
    this.form.image = file

    const image = new Image()
    const reader = new FileReader()
    reader.onload = (e) => {
      this.image = (e.target as any).result
    }
    reader.readAsDataURL(file)
  }

  removeImage(e) {
    this.image = ''
  }

  async onUpdate() {
    const guestErrors = []
    if (!this.form.name || this.form.name.indexOf('guest_') != -1) {
      guestErrors.push('名前を変更してください')
    }
    if (!this.form.email || this.form.email.indexOf('guest_') != -1) {
      guestErrors.push('メールアドレスを変更してください')
    }
    if (!this.form.password) {
      guestErrors.push('パスワードを入力してください')
    }
    if (guestErrors.length > 0) {
      userState.setErrorMessage(guestErrors.join("<br>"))
      return
    }
    if (this.form.password && !this.form.isSamePass) {
      userState.setErrorMessage('パスワード（再入力）とパスワードの入力が一致しません')
      return
    }
    if (!this.isLoading) {
      await userState.updateUser({
        userForm: this.form
      })

      this.completeDialog = true
    }
  }
}
